import React from 'react';

import TransitBadge from '../TransitBadge';
import { IconPedestrian } from '../../Icons';


const LegBody = props => {
    const { details, text } = props;
    // console.log(details);
    let wrapperClass = 'otp-trip-leg-details';
    if (details.mode === 'WALK') {
        wrapperClass += ' otp-walking-directions';
    }
    return (
        <div className={wrapperClass}>
            <div className="otp-icon-wrapper">{getDefaultIcon(details)}</div>
            <div className="otp-trip-divider"></div>
            <div className="otp-trip-text">{text}</div>
        </div>
    );
};

const getDefaultIcon = details => {
    if (details.mode === 'WALK') {
        return <IconPedestrian />;
    }
    if (details.mode === 'BUS') {
        return <TransitBadge leg={details} showName={false} />;
    }
};

export default LegBody;